import React from 'react';

const AsyncReportsMonitoring = React.lazy(() => import('./ReportsMonitoringContainer'));

export const ReportsMonitoringPage = () => {
  return <AsyncReportsMonitoring />;
};
